// Copyright (c) 2020 Deere & Company
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import { translate } from '../../../sharedmodules/services/translation-service';

export const maxNotifcationId = (notifications) => Math.max.apply(null,
    notifications.map((notification) => notification.id));

export const getMaxNotificationId = (notifications) => notifications.length > 0 ?
    Math.max(...notifications.map((list) => maxNotifcationId(list.notifications))) :
    0;

export const isNotEmpty = (value) => !(/^\s*$/.test(value)) && !(value === null);

export const isValidNofication = (fied) => [
    isNotEmpty(fied.title),
    isNotEmpty(fied.shortText),
].every((rule) => rule);

export const modifyNotificationCards = (notificationIdState, dragIndex, hoverIndex) => {

    const card = notificationIdState[dragIndex];
    const index = notificationIdState.indexOf(card);
    const newcards = notificationIdState;
    newcards.splice(index, 1);
    newcards.splice(hoverIndex, 0, card);
    return newcards;

};
export const isEqualArrayContent = (srcarr, dstarr) => _.isEqual(srcarr, dstarr);

export const translatedNoficationTitle = (key) => {

    const notificationMessages = {
        DE: 'GERMAN',
        EN: 'ENGLISH',
        ES: 'SPANISH',
        FI: 'FINNISH',
        FR: 'FRENCH',
        IT: 'ITALIAN',
        PL: 'POLISH',
        PT: 'PORTUGUESE',
        RU: 'RUSSIAN',
        SV: 'SWEDISH',
        TR: 'TURKISH',
        ZH: 'CHINESE',

    };
    return notificationMessages[key] ? translate(notificationMessages[key]) : key;

};

export const notificationTitleTranslate = (count, languagecode) => `${translate('MESSAGE')} ${count} - ${translatedNoficationTitle(languagecode)}`;
